import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import {
  countdownContainerStyles,
  countdownNumberContainerStyles,
  countdownNumberStyles,
  countdownStartTextStyles,
  countdownInstructionTextStyles,
  countdownCircleStyles,
} from "./styles";

interface CountdownStartProps {
  onCountdownComplete: () => void;
  instructionText?: string;
}

export const CountdownStart: React.FC<CountdownStartProps> = ({
  onCountdownComplete,
  instructionText = "Get ready to start the dialogue",
}) => {
  const [count, setCount] = useState(3);
  const [showStart, setShowStart] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev > 1) {
          return prev - 1;
        } else {
          setShowStart(true);
          clearInterval(timer);
          setTimeout(() => {
            onCountdownComplete();
          }, 1000);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onCountdownComplete]);

  return (
    <Box sx={countdownContainerStyles}>
      <Box sx={countdownNumberContainerStyles}>
        <Box sx={countdownCircleStyles} />
        {!showStart ? (
          <Typography
            sx={{
              ...countdownNumberStyles,
              background: "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow:
                "0 0 40px rgba(40, 201, 220, 0.8), 0 0 80px rgba(123, 73, 193, 0.6)",
              color: "#ffffff",
            }}
          >
            {count}
          </Typography>
        ) : (
          <Typography
            sx={{
              ...countdownStartTextStyles,
              background: "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow:
                "0 0 40px rgba(40, 201, 220, 0.8), 0 0 80px rgba(123, 73, 193, 0.6)",
              color: "#ffffff",
            }}
          >
            START
          </Typography>
        )}
      </Box>

      <Typography
        sx={{
          ...countdownInstructionTextStyles,
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(135deg, #ccc 0%, #fff 100%)"
              : "linear-gradient(135deg, #666 0%, #999 100%)",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {instructionText}
      </Typography>
    </Box>
  );
};
